import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'highLightText',
  standalone: true,
})
export class HighLightTextPipe implements PipeTransform {
  public constructor() {}

  public transform(value: string | number | undefined, text: string): string {
    if (!value) {
      return ''
    }
    if (typeof value !== 'string') value = value?.toString()
    if (text === '') {
      return value
    }

    const regex = new RegExp(`(${text})`, 'gi')
    return value.replace(regex, '<mark class="p-0">$1</mark>')
  }
}
